// extracted by mini-css-extract-plugin
export default {"root":"UserInputBubble_root__Y4II+"};